export default function CheckMark(props) {
    const shadow = props.shadow ?? '#0aa06e';
    const fill = props.fill ?? '#32ba7c';
    const isLegend = props.isLegend;
    if (isLegend) {
        return (
            <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                fill="none"
            >
                <circle cx="8" cy="8" r="8" fill="var(--color-blue)" />
                <path
                    fill="#fff"
                    d="m12.4 6.406-5.124 5.151a.784.784 0 0 1-1.115 0L3.6 8.982a.794.794 0 0 1 0-1.121.784.784 0 0 1 1.115 0L6.72 9.876l4.567-4.59a.784.784 0 0 1 1.114 0c.308.309.308.81 0 1.12Z"
                />
            </svg>
        );
    }

    return (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 507.2 507.2">
            <circle cx="253.6" cy="253.6" r="253.6" {...{ fill }} />
            <path
                d="M188.8 368l130.4 130.4c108-28.8 188-127.2 188-244.8v-7.2L404.8 152l-216 216z"
                fill={shadow}
            />
            <g fill="#fff">
                <path d="M260 310.4c11.2 11.2 11.2 30.4 0 41.6l-23.2 23.2c-11.2 11.2-30.4 11.2-41.6 0L93.6 272.8c-11.2-11.2-11.2-30.4 0-41.6l23.2-23.2c11.2-11.2 30.4-11.2 41.6 0L260 310.4z" />
                <path d="M348.8 133.6c11.2-11.2 30.4-11.2 41.6 0l23.2 23.2c11.2 11.2 11.2 30.4 0 41.6l-176 175.2c-11.2 11.2-30.4 11.2-41.6 0l-23.2-23.2c-11.2-11.2-11.2-30.4 0-41.6l176-175.2z" />
            </g>
        </svg>
    );
}
